function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QPageSticky from '../page-sticky/QPageSticky.js';
import { getScrollTarget, setScrollPosition } from '../../utils/scroll.js';
export default Vue.extend({
  name: 'QPageScroller',
  mixins: [QPageSticky],
  props: {
    scrollOffset: {
      type: Number,
      "default": 1000
    },
    reverse: Boolean,
    duration: {
      type: Number,
      "default": 300
    },
    offset: {
      "default": function _default() {
        return [18, 18];
      }
    }
  },
  inject: {
    layout: {
      "default": function _default() {
        console.error('QPageScroller needs to be used within a QLayout');
      }
    }
  },
  data: function data() {
    return {
      showing: this.__isVisible()
    };
  },
  computed: {
    scrollHeight: function scrollHeight() {
      return this.layout.height - (this.layout.container === true ? this.layout.containerHeight : this.$q.screen.height);
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        click: this.__onClick
      });
    }
  },
  watch: {
    'layout.scroll.position': function layoutScrollPosition() {
      this.__updateVisibility();
    },
    reverse: {
      handler: function handler(val) {
        if (val === true) {
          if (this.heightWatcher === void 0) {
            this.heightWatcher = this.$watch('scrollHeight', this.__updateVisibility);
          }
        } else if (this.heightWatcher !== void 0) {
          this.__cleanup();
        }
      },
      immediate: true
    }
  },
  methods: {
    __isVisible: function __isVisible() {
      return this.reverse === true ? this.scrollHeight - this.layout.scroll.position > this.scrollOffset : this.layout.scroll.position > this.scrollOffset;
    },
    __onClick: function __onClick(e) {
      var target = getScrollTarget(this.layout.container === true ? this.$el : this.layout.$el);
      setScrollPosition(target, this.reverse === true ? this.layout.height : 0, this.duration);
      this.$emit('click', e);
    },
    __updateVisibility: function __updateVisibility() {
      var newVal = this.__isVisible();

      if (this.showing !== newVal) {
        this.showing = newVal;
      }
    },
    __cleanup: function __cleanup() {
      this.heightWatcher();
      this.heightWatcher = void 0;
    }
  },
  render: function render(h) {
    return h('transition', {
      props: {
        name: 'q-transition--fade'
      }
    }, this.showing === true ? [h('div', {
      staticClass: 'q-page-scroller',
      on: this.onEvents
    }, [QPageSticky.options.render.call(this, h)])] : null);
  },
  beforeDestroy: function beforeDestroy() {
    this.heightWatcher !== void 0 && this.__cleanup();
  }
});